import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import AuthenticatedRoute from "../auth/AuthenticatedRoutes";
import * as URLS from "../../const/URL.const";
import ErrorContainer from "../../container/ErrorContainer";
import HomeContainer from "../../container/HomeContainer";
import MenuContainer from "../../container/MenuContainer";
import { MenuContainerTabs } from "../Routes";
import { ProductsContainer } from "../menu/products/ProductsContainer";
import { TaxesContainer } from "../taxes/TaxesContainer";
import { DiscountsContainer } from "../discounts/DiscountContainer";
import { SubscriptionsContainer } from "../subscription/SubscriptionsContainer";
import VenueImporterView from "../../container/VenueImporterView";
import EmailVerificationPage from "../../container/VenueImporterView/EmailVerificationPage";
import { SignupContainer } from "../../container/SignupContainer";
import { WelcomeContainer } from "../signup/newVenue/WelcomeContainer";
import SquareOAuthRedirect from "../../container/SquareOAuthRedirect";
import NotFound from "../../container/NotFound";
import VenuesOverviewContainer from "../../container/VenuesOverviewContainer";
import { OrderRouter } from "../orders/OrderRouter";
import CreateUserMerchant from "../../container/CreateUserMerchant";
import NoVenuesView from "../../container/NoVenuesView";
import { PERMISSIONS } from "../../const/permissions.const";
import { VenueStartupContainer } from "../../container/VenueStartupContainer";
import { VenueWrapper } from "../util/VenueWrapper";
import { PaymentsRoute } from "../menu/payments/PaymentRoutes";
import Reviews from "../../container/Reviews/Reviews";
import { useSetLaunchDarklyUser } from "../../hooks/useSetLaunchDarklyUser";
import { GroupManagementContainer } from "../groupsManagement/GroupManagementContainer";
import { useHubspotChat } from "../../hooks/useHubspotchat";

const AppRouter = () => {
  useSetLaunchDarklyUser();
  useHubspotChat(6892734);

  return (
    <Router>
      <Switch>
        <Route path={URLS.ERROR_URL} component={ErrorContainer} exact={true} />
        <Route
          path={URLS.EMAIL_VERIFICATION_URL}
          component={EmailVerificationPage}
          exact
        />
        <Route
          path={URLS.SELF_SIGNUP_URL}
          component={SignupContainer}
          exact={true}
        />
        <Route
          path={URLS.SQUARE_OAUTH_REDIRECT}
          component={SquareOAuthRedirect}
          exact={true}
        />
        <Route
          path={[
            URLS.HOME_URL,
            URLS.RESET_PASSWORD_URL,
            URLS.FORGOT_PASSWORD_URL,
          ]}
          component={HomeContainer}
          exact={true}
        />

        <Route exact={true} path={URLS.NEW_MERCHANT}>
          <WelcomeContainer />
        </Route>
        <Route path={URLS.VENUE_IMPORTER_URL}>
          <VenueImporterView />
        </Route>
        <Route path={URLS.EMAIL_VERIFICATION_URL}>
          <EmailVerificationPage />
        </Route>
        <Route path={URLS.CREATE_USER_MERCHANT}>
          <CreateUserMerchant />
        </Route>
        <Route path={URLS.NO_VENUES}>
          <NoVenuesView />
        </Route>
        <Route path={URLS.NO_PERMISSIONS} component={NotFound} />
        <AuthenticatedRoute>
          <Route exact path={URLS.VENUES}>
            <VenueStartupContainer />
          </Route>
          <Route path={URLS.VENUES_OVERVIEW}>
            <VenuesOverviewContainer />
          </Route>
          <Route path={URLS.GROUPS_MANAGEMENT_URL}>
            <GroupManagementContainer />
          </Route>
          <VenueWrapper>
            <>
              <Route path={[URLS.PROFILE_DETAILS_URL]}>
                <MenuContainer tab={MenuContainerTabs.DETAILS} />
              </Route>
              <Route path={[URLS.USER_MANAGEMENT]}>
                <MenuContainer tab={MenuContainerTabs.USER_MANAGEMENT} />
              </Route>
              <Route path={URLS.PRODUCTS_URL}>
                <ProductsContainer />
              </Route>
              <Route
                path={URLS.TAXES_URL}
                render={(props) => (
                  <TaxesContainer {...props} tab={MenuContainerTabs.TAXES} />
                )}
              />
              <Route path={URLS.ORDERS_URL}>
                <OrderRouter />
              </Route>
              <Route
                exact
                path={[URLS.PROFILE_URL, URLS.ANALYTICS_DASHBOARD_URL]}
              >
                <MenuContainer
                  tab={MenuContainerTabs.DASHBOARD}
                  requiredPermission={PERMISSIONS.REPORTING}
                />
              </Route>
              <Route path={URLS.PROFILE_EPOS_NOW}>
                <MenuContainer tab={MenuContainerTabs.EPOSNOW} />
              </Route>
              <Route path={URLS.PROFILE_MENU_SYNC}>
                <MenuContainer tab={MenuContainerTabs.MENU_SYNC} />
              </Route>
              <Route path={URLS.CUSTOMERS}>
                <MenuContainer
                  tab={MenuContainerTabs.CUSTOMERS}
                  requiredPermission={PERMISSIONS.REPORTING}
                />
              </Route>
              <Route path={URLS.PROFILE_PAYMENTS_URL}>
                <MenuContainer
                  tab={MenuContainerTabs.PAYMENTS}
                  requiredPermission={PERMISSIONS.BILLING_AND_PAYMENT}
                />
              </Route>
              <Route path={URLS.PROFILE_VENUE_URL}>
                <MenuContainer tab={MenuContainerTabs.VENUE_URL} />
              </Route>
              <Route path={URLS.PROFILE_DOWNLOAD_QR_CODE}>
                <MenuContainer tab={MenuContainerTabs.DOWNLOAD_QR_CODE} />
              </Route>
              <Route path={URLS.SUBSCRIPTION_URL}>
                <SubscriptionsContainer
                  tab={MenuContainerTabs.SUBSCRIPTIONS}
                  requiredPermission={PERMISSIONS.BILLING_AND_PAYMENT}
                />
              </Route>
              <Route path={URLS.PROFILE_REPORTS_URL}>
                <MenuContainer
                  tab={MenuContainerTabs.REPORTS}
                  requiredPermission={PERMISSIONS.REPORTING}
                />
              </Route>
              <Route path={URLS.PROFILE_VENUE_IMAGES}>
                <MenuContainer tab={MenuContainerTabs.VENUEIMAGES} />
              </Route>
              <Route path={URLS.DISCOUNTS_URL}>
                <DiscountsContainer tab={MenuContainerTabs.DISCOUNTS} />
              </Route>
              <Route path={URLS.SQUARE_SYNC}>
                <MenuContainer tab={MenuContainerTabs.SQUARE_SYNC} />
              </Route>
              <Route path={URLS.PROFILE_EXTERNAL_LINKS}>
                <MenuContainer tab={MenuContainerTabs.EXTERNAL_LINKS} />
              </Route>
              <Route path={URLS.PROFILE_TRADING_TIMES_URL}>
                <MenuContainer tab={MenuContainerTabs.TRADING_TIMES} />
              </Route>
              <Route path={URLS.PROFILE_ORDER_SETTINGS_URL}>
                <MenuContainer tab={MenuContainerTabs.ORDER_SETTINGS} />
              </Route>
              <Route path={URLS.PROFILE_SETTINGS_URL}>
                <MenuContainer tab={MenuContainerTabs.VENUE_SETTINGS} />
              </Route>
              <Route path={URLS.PROFILE_PAYMENTS_URL}>
                <PaymentsRoute />
              </Route>
              <Route path={URLS.REVIEWS_URL}>
                <Reviews
                  tab={MenuContainerTabs.REVIEWS}
                  requiredPermission={PERMISSIONS.REPORTING}
                />
              </Route>
              <Route path={URLS.PROFILE_PRINTER_SETTINGS}>
                  <MenuContainer tab={MenuContainerTabs.PRINTER_SETTINGS} />
              </Route>
            </>
          </VenueWrapper>
        </AuthenticatedRoute>
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

export default AppRouter;
